import { type ReactNode } from 'react';
import { buttonVariants } from 'v5/design-system/Button';

export type FullPageDashboardLinkProps = {
  href: string;
  children: ReactNode;
};

export function FullPageDashboardLink({
  href,
  children
}: FullPageDashboardLinkProps) {
  return (
    <a
      href={href}
      className={buttonVariants({ variant: 'secondary', size: 'md' })}
    >
      {children}
    </a>
  );
}
